import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../../common/OverlayLoader.store';
import { JobDatasets } from '../../components/details/JobDatasets';
import { IJobDetailsService } from '../../jobDetails.service';
import { IJobDetailsFormsBl } from '../../jobDetailsForms.bl';
import { useJobPermissions } from '../../jobPermissions';
import { INFERENCE_TYPE, JOB_STATUS } from '../../jobs.model';
import { withValidType } from './withValidType';

export const JobDatasetsContainer = withValidType(
  observer((): ReactElement => {
    const jobDetailsService = useInjection(IJobDetailsService.$);
    const jobDetailsForms = useInjection(IJobDetailsFormsBl.$);
    const overlayLoader = useInjection(IOverlayLoaderStore.$);
    const permissions = useJobPermissions();
    const {
      dataSources: { datasets },
      job: { isOwner, status, datasetIds, type },
      jobType,
    } = jobDetailsService.store;

    const changeDatasetSelection = async (e: ChangeEvent<HTMLInputElement>): Promise<void> => {
      await jobDetailsForms.toggleDatasetAsync(e.target.value, { addative: true });
    };

    const hasPermission = permissions.canUpdate(isOwner);
    const editableStatus = status === JOB_STATUS.DRAFT || status === JOB_STATUS.STOPPED || status === JOB_STATUS.FAILED;
    const inferenceOnDataset = type === INFERENCE_TYPE.DATASET;
    const isLoading = status === JOB_STATUS.UNKNOWN || overlayLoader.isSpinnerVisible('job-datasets-table');

    return (
      <JobDatasets
        jobType={jobType}
        isFormDisabled={!hasPermission || !editableStatus || inferenceOnDataset || isLoading}
        datasets={datasets}
        datasetIds={datasetIds}
        isLoading={isLoading}
        toggleDataset={changeDatasetSelection}
        toggleAllDatasets={async () => jobDetailsForms.toggleAllDatasetsAsync({ forceAll: false })}
        isInferenceOnDataset={inferenceOnDataset}
      />
    );
  })
);
